import React from 'react'
import SearchFrom from '../components/SearchFrom'
import CocktailList from '../components/CocktailList'

const Home = () => {
  return (
   <main>
    <SearchFrom/>
    <CocktailList/>
   </main>
  )
}

export default Home
